import { Checkbox } from 'journey-ui'
import React, { SetStateAction, useCallback, useContext } from 'react'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { PortionInput } from './PortionInput'
import { HalfAndHalfSelect } from './HalfAndHalfSelect'
import { ToppingOptionSelect } from './ToppingOptionSelect'
import { ToppingContext } from '../../contexts/ToppingContext'
import { useToppingPriceLabel } from '../../hooks/useToppingPriceLabel'
import { sum } from '../../helpers'

interface Props {
  topping: ItemTopping
  tile: Tile
}

export const ToppingRow: React.FC<Props> = ({ topping, tile }) => {
  const { form, item, setForm } = useContext(ItemPageContext)
  const { name, hash_id, is_removable, is_hah_disabled } = topping

  const removeTopping = useCallback(() => {
    setForm((form) => {
      const newToppings = form.toppings.filter((t) => t.hash_id !== hash_id)
      const prevToppingPrice = sum(form.toppings.map((t) => t.price)) * form.quantity
      const newToppingsPrice = sum(newToppings.map((t) => t.price)) * form.quantity

      return {
        ...form,
        price: form.price - prevToppingPrice + newToppingsPrice,
        toppings: newToppings,
      }
    })
  }, [setForm, hash_id])

  const setTopping = useCallback((newToppingAction: SetStateAction<ItemTopping>) => {
    const newTopping = newToppingAction instanceof Function ? newToppingAction(topping) : newToppingAction

    setForm((form) => ({
      ...form,
      toppings: form.toppings.map((t) => (t.hash_id === newTopping.hash_id ? newTopping : t)),
    }))
  }, [setForm, topping])

  return (
    <ToppingContext.Provider value={{ topping, setTopping }}>
      <div>
        <div className="text-sm flex justify-between items-center p-2">
          <div className="w-28 flex items-center flex-nowrap space-x-2">
            {is_removable ? <Checkbox checked onClick={removeTopping} /> : null}
            <div className="flex-shrink-0">
              <div>{name}</div>
              <div className="text-xs">{useToppingPriceLabel(topping)}</div>
            </div>
          </div>
          <div className="space-y-1 flex items-end flex-col">
            <PortionInput />
            {item.has_hah && !is_hah_disabled ? <HalfAndHalfSelect /> : null}
          </div>
        </div>

        <ToppingOptionSelect />
      </div>
    </ToppingContext.Provider>
  )
}
